import { combineReducers } from 'redux';

import byId from './byId/reducer';
import feedQuestionnairesSubmission from './feedQuestionnairesSubmission/reducer';

export default combineReducers({
  byId,
  feedQuestionnairesSubmission
});



/** WEBPACK FOOTER **
 ** ./src/members/state/feed/feedQuestionnaires/reducer.js
 **/